// Marquee duplicate
(function(){ const t=document.getElementById('mt'); if(t) t.innerHTML+=t.innerHTML; })();

// Scroll reveal
const ro=new IntersectionObserver((es)=>{ es.forEach((e,i)=>{ if(e.isIntersecting){ setTimeout(()=>e.target.classList.add('in'),i*60); ro.unobserve(e.target); } }); },{threshold:.08});
document.querySelectorAll('.reveal').forEach(el=>ro.observe(el));

// Counters
function cu(el,t){ let c=0; const s=t/1600*16; const tm=setInterval(()=>{ c=Math.min(c+s,t); const suf=el.querySelector('.r'); const txt=Math.floor(c).toLocaleString('es-PE'); el.innerHTML=txt+(suf?'<span class="r">'+suf.textContent+'</span>':''); if(c>=t)clearInterval(tm); },16); }
const co=new IntersectionObserver((es)=>{ es.forEach(e=>{ if(e.isIntersecting){ const t=parseInt(e.target.dataset.target); if(t)cu(e.target,t); co.unobserve(e.target); } }); },{threshold:.5});
document.querySelectorAll('[data-target]').forEach(el=>co.observe(el));

// Burger menu
const burger=document.querySelector('.burger');
const mobileMenu=document.getElementById('mobile-menu');
if(burger&&mobileMenu){
  burger.addEventListener('click',()=>{
    const open=mobileMenu.classList.toggle('open');
    burger.classList.toggle('active',open);
  });
  document.addEventListener('click',e=>{
    if(!burger.contains(e.target)&&!mobileMenu.contains(e.target)){
      mobileMenu.classList.remove('open');
      burger.classList.remove('active');
    }
  });
}

// ── SECURITY: HTML escape to prevent XSS in dynamic content ─────────────────
function esc(str) {
  return String(str == null ? '' : str)
    .replace(/&/g,'&amp;').replace(/</g,'&lt;').replace(/>/g,'&gt;')
    .replace(/"/g,'&quot;').replace(/'/g,'&#x27;');
}

// ── SCROLL LOCK (iOS-safe) ───────────────────────────────────────────────────
let _scrollY=0, _lockCount=0;
function lockScroll(){
  if(_lockCount===0){
    _scrollY=window.scrollY;
    document.body.style.top='-'+_scrollY+'px';
    document.body.classList.add('scroll-locked');
  }
  _lockCount++;
}
function unlockScroll(){
  _lockCount=Math.max(0,_lockCount-1);
  if(_lockCount===0){
    document.body.classList.remove('scroll-locked');
    document.body.style.top='';
    document.documentElement.style.scrollBehavior='auto';
    window.scrollTo(0,_scrollY);
    document.documentElement.style.scrollBehavior='';
  }
}

// ── PRODUCT RENDERING ────────────────────────────────────────────────────────
const WA_SVG=`<svg viewBox="0 0 24 24" fill="currentColor" width="13" height="13"><path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z"/></svg>`;

let _carouselTimers=[];

function renderProducts(filter='all'){
  const grid=document.getElementById('prod-grid');
  if(!grid) return;
  _carouselTimers.forEach(id=>clearInterval(id));
  _carouselTimers=[];
  const products=Store.getProducts();
  const filtered=filter==='all'?products:products.filter(p=>p.category===filter);
  if(!filtered.length){
    grid.innerHTML='<div class="no-products">No hay productos en esta categoría aún.</div>';
    return;
  }
  grid.innerHTML=filtered.map(p=>{
    const badgeHtml=p.badge?`<span class="pbadge${p.badge==='NEW'?' new':''}">${p.badge}</span>`:'';
    const imgs=p.images&&p.images.length?p.images:(p.imageUrl?[p.imageUrl]:[]);
    let imgHtml='';
    if(imgs.length>1){
      imgHtml=`<div class="pimg-car">
        ${imgs.map((u,i)=>`<img src="${u}" alt="${p.name}" class="pimg-slide${i===0?' active':''}" loading="${i===0?'eager':'lazy'}">`).join('')}
        <div class="pimg-dots">${imgs.map((_,i)=>`<button class="pimg-dot${i===0?' active':''}" data-pi="${i}"></button>`).join('')}</div>
      </div>`;
    } else if(imgs.length===1){
      imgHtml=`<img src="${imgs[0]}" alt="${p.name}" loading="lazy" onerror="this.style.display='none';this.nextElementSibling.style.opacity='.25'">`;
    }
    const firstBox=p.boxOptions&&p.boxOptions.length?p.boxOptions[0]:null;
    const minUnit=p.boxOptions&&p.boxOptions.length?Math.min(...p.boxOptions.map(b=>b.pricePerUnit)):p.price;
    const priceText=p.boxOptions&&p.boxOptions.length>1?`Desde S/ ${minUnit.toFixed(2)}/u`:`S/ ${(firstBox?firstBox.pricePerUnit:p.price).toFixed(2)}/u`;
    const boxNote=firstBox?`📦 Caja mín. ×${firstBox.units} unids`:'';
    return `<div class="pc reveal" data-id="${esc(p.id)}">
      <div class="pimg">
        ${imgHtml}${imgs.length===0?`<span class="pej">${p.emoji||'📦'}</span>`:''}
        ${badgeHtml}
        <span class="pmay-tag">AL POR MAYOR</span>
        <button class="pwab" data-qid="${esc(p.id)}" title="Añadir al carrito">${WA_SVG} Añadir</button>
      </div>
      <div class="pinfo">
        <p class="pbrand">${p.brand}</p>
        <p class="pname">${p.name}</p>
        ${p.sizesInfo?`<p class="psizes-tag">📏 ${p.sizesInfo}</p>`:''}
        <p class="pprice">${priceText}</p>
        ${boxNote?`<p class="pbox-note">${boxNote}</p>`:''}
      </div>
    </div>`;
  }).join('');
  grid.querySelectorAll('.reveal').forEach(el=>ro.observe(el));
  grid.querySelectorAll('.pc').forEach(card=>{
    card.addEventListener('click',()=>openModal(card.dataset.id));
  });
  grid.querySelectorAll('.pwab').forEach(btn=>{
    btn.addEventListener('click',e=>{e.stopPropagation();quickAdd(btn.dataset.qid);});
  });
  initProductCarousels();
}

function initProductCarousels(){
  document.querySelectorAll('.pimg-car').forEach(car=>{
    const slides=car.querySelectorAll('.pimg-slide');
    const dots=car.querySelectorAll('.pimg-dot');
    if(slides.length<2) return;
    let cur=0;
    function goTo(n){
      slides[cur].classList.remove('active');dots[cur].classList.remove('active');
      cur=(n+slides.length)%slides.length;
      slides[cur].classList.add('active');dots[cur].classList.add('active');
    }
    const timer=setInterval(()=>goTo(cur+1),3500);
    _carouselTimers.push(timer);
    dots.forEach(d=>d.addEventListener('click',e=>{e.stopPropagation();goTo(+d.dataset.pi);}));
  });
}

function quickAdd(id){
  const p=Store.getProduct(id);
  if(!p) return;
  openModal(id);
}

// ── CATEGORY FILTER ──────────────────────────────────────────────────────────
document.querySelectorAll('[data-filter]').forEach(btn=>{
  btn.addEventListener('click',function(){
    document.querySelectorAll('[data-filter]').forEach(b=>b.classList.remove('active'));
    this.classList.add('active');
    renderProducts(this.dataset.filter);
  });
});

// ── PRODUCT MODAL ────────────────────────────────────────────────────────────
let _modalTimer=null;

function openModal(id){
  const p=Store.getProduct(id);
  if(!p) return;
  if(_modalTimer){ clearInterval(_modalTimer); _modalTimer=null; }
  const m=document.getElementById('prod-modal');
  const imgs=p.images&&p.images.length?p.images:(p.imageUrl?[p.imageUrl]:[]);
  const car=document.getElementById('m-img-car');
  const emojiEl=document.getElementById('m-emoji');
  if(imgs.length){
    emojiEl.style.display='none';
    car.innerHTML=imgs.map((u,i)=>`<img src="${u}" alt="${p.name}" class="pm-slide${i===0?' active':''}" loading="${i===0?'eager':'lazy'}">`).join('')
      +(imgs.length>1?`<div class="pm-img-dots">${imgs.map((_,i)=>`<button class="pm-dot${i===0?' active':''}" data-mi="${i}"></button>`).join('')}</div>`:'');
    if(imgs.length>1){
      const mSlides=car.querySelectorAll('.pm-slide'),mDots=car.querySelectorAll('.pm-dot');
      let mc=0;
      function mGoTo(n){mSlides[mc].classList.remove('active');mDots[mc].classList.remove('active');mc=(n+mSlides.length)%mSlides.length;mSlides[mc].classList.add('active');mDots[mc].classList.add('active');}
      mDots.forEach(d=>d.addEventListener('click',()=>mGoTo(+d.dataset.mi)));
      _modalTimer=setInterval(()=>mGoTo(mc+1),4000);
    }
  } else {
    car.innerHTML='';
    emojiEl.textContent=p.emoji||'📦';
    emojiEl.style.display='flex';
  }
  document.getElementById('m-brand').textContent=p.brand;
  document.getElementById('m-name').textContent=p.name;
  const firstBoxOpt=p.boxOptions&&p.boxOptions.length?p.boxOptions[0]:null;
  document.getElementById('m-price').textContent=firstBoxOpt?`S/ ${firstBoxOpt.totalPrice.toFixed(2)}`:`S/ ${p.price.toFixed(2)}`;
  document.getElementById('m-desc').textContent=p.description||'';

  // Reset add button state before rendering options
  const mAddBtn=document.getElementById('m-add');
  mAddBtn.dataset.id=id;
  mAddBtn.dataset.box='';

  // Box options
  const sizesWrap=document.getElementById('m-sizes');
  sizesWrap.innerHTML='';
  const infoEl=document.createElement('p');
  infoEl.className='m-ref-note';
  infoEl.textContent='* Las imágenes son referenciales';
  sizesWrap.appendChild(infoEl);
  if(p.boxOptions&&p.boxOptions.length){
    const label=document.createElement('p');
    label.className='m-size-label';
    label.textContent='Selecciona tu caja:';
    sizesWrap.appendChild(label);
    const row=document.createElement('div');
    row.className='m-size-row';
    p.boxOptions.forEach(opt=>{
      const btn=document.createElement('button');
      btn.className='size-btn box-btn';
      btn.innerHTML=`<span class="box-lbl">${opt.label}</span><span class="box-prc">S/ ${opt.totalPrice.toFixed(2)}</span><span class="box-unit">S/ ${opt.pricePerUnit.toFixed(2)}/u</span>`;
      btn.addEventListener('click',()=>{
        row.querySelectorAll('.size-btn').forEach(b=>b.classList.remove('sel'));
        btn.classList.add('sel');
        mAddBtn.dataset.box=JSON.stringify(opt);
        document.getElementById('m-price').textContent=`S/ ${opt.totalPrice.toFixed(2)}`;
      });
      row.appendChild(btn);
    });
    sizesWrap.appendChild(row);
    // Auto-select when only one option — direct state assignment instead of .click() for iOS compatibility
    if(p.boxOptions.length===1){
      const firstBtn=row.querySelector('.size-btn');
      if(firstBtn){
        firstBtn.classList.add('sel');
        mAddBtn.dataset.box=JSON.stringify(p.boxOptions[0]);
      }
    }
  }

  // Colors (no longer used)
  document.getElementById('m-colors').innerHTML='';
  document.getElementById('m-wa').href=`https://wa.me/${WA}?text=${encodeURIComponent('Hola! Me interesa: '+p.brand+' '+p.name)}`;
  m.classList.add('open');
  lockScroll();
}

function closeModal(){
  if(_modalTimer){ clearInterval(_modalTimer); _modalTimer=null; }
  document.getElementById('prod-modal').classList.remove('open');
  unlockScroll();
}

document.getElementById('m-add')?.addEventListener('click',function(){
  const id=this.dataset.id;
  const p=Store.getProduct(id);
  if(!p) return;
  let boxOption=null;
  try{ if(this.dataset.box) boxOption=JSON.parse(this.dataset.box); }catch(e){}
  if(p.boxOptions&&p.boxOptions.length&&!boxOption){ showToast('Selecciona una caja primero'); return; }
  Store.addToCart(id,boxOption);
  updateCartUI();
  closeModal();
  showToast(`${p.name} añadido al carrito`);
});

document.getElementById('prod-modal')?.addEventListener('click',e=>{
  if(e.target===document.getElementById('prod-modal')) closeModal();
});
document.getElementById('m-close')?.addEventListener('click',closeModal);

// ── CART UI ──────────────────────────────────────────────────────────────────
function updateCartUI(){
  const count=Store.cartCount();
  document.querySelectorAll('.cart-badge').forEach(b=>{ b.textContent=count; b.style.display=count?'flex':'none'; });
  renderCartItems();
}

function renderCartItems(){
  const list=document.getElementById('cart-list');
  const totalEl=document.getElementById('cart-total');
  const emptyEl=document.getElementById('cart-empty');
  const actionsEl=document.getElementById('cart-actions');
  if(!list) return;
  const cart=Store.getCart();
  if(!cart.length){
    list.innerHTML='';
    if(emptyEl) emptyEl.style.display='flex';
    if(actionsEl) actionsEl.style.display='none';
    return;
  }
  if(emptyEl) emptyEl.style.display='none';
  if(actionsEl) actionsEl.style.display='block';
  list.innerHTML=cart.map(item=>{
    const unitStr=item.pricePerUnit!=null?' · S/ '+Number(item.pricePerUnit).toFixed(2)+'/u':'';
    const varStr=item.boxLabel?` <em>(${esc(item.boxLabel)}${unitStr})</em>`:'';
    const safeKey=esc(item.key);
    return `
    <div class="cart-item" data-key="${safeKey}">
      <div class="ci-info">
        <span class="ci-brand">${esc(item.brand)}</span>
        <span class="ci-name">${esc(item.name)}${varStr}</span>
        <span class="ci-price">S/ ${Number(item.price).toFixed(2)}/caja</span>
      </div>
      <div class="ci-controls">
        <button class="qty-btn" data-action="dec">−</button>
        <span class="qty-num">${Number(item.qty)}</span>
        <button class="qty-btn" data-action="inc">+</button>
        <button class="remove-btn" data-action="remove">✕</button>
      </div>
    </div>`;
  }).join('');
  if(totalEl) totalEl.textContent=`S/ ${Store.cartTotal().toFixed(2)}`;
}

function changeQty(key,delta){
  const cart=Store.getCart();
  const item=cart.find(i=>i.key===key);
  if(item) Store.updateQty(key,item.qty+delta);
  updateCartUI();
}

function removeItem(key){ Store.removeFromCart(key); updateCartUI(); }

document.getElementById('cart-list')?.addEventListener('click',function(e){
  const btn=e.target.closest('[data-action]');
  if(!btn) return;
  const key=btn.closest('.cart-item')?.dataset.key;
  if(!key) return;
  const action=btn.dataset.action;
  if(action==='dec') changeQty(key,-1);
  else if(action==='inc') changeQty(key,1);
  else if(action==='remove') removeItem(key);
});

function openCart(){ document.getElementById('cart-panel').classList.add('open'); document.getElementById('cart-overlay').classList.add('open'); lockScroll(); }
function closeCart(){ document.getElementById('cart-panel').classList.remove('open'); document.getElementById('cart-overlay').classList.remove('open'); unlockScroll(); }

document.getElementById('cart-btn')?.addEventListener('click',openCart);
document.getElementById('cart-close')?.addEventListener('click',closeCart);
document.getElementById('cart-overlay')?.addEventListener('click',closeCart);

document.getElementById('clear-cart-btn')?.addEventListener('click',()=>{
  if(confirm('¿Vaciar carrito?')){ Store.clearCart(); updateCartUI(); }
});

// ── TOAST ────────────────────────────────────────────────────────────────────
function showToast(msg){
  let t=document.getElementById('toast');
  if(!t){ t=document.createElement('div'); t.id='toast'; document.body.appendChild(t); }
  t.textContent=msg;
  t.classList.add('show');
  clearTimeout(t._tm);
  t._tm=setTimeout(()=>t.classList.remove('show'),2800);
}

// ── INIT ─────────────────────────────────────────────────────────────────────
renderProducts();
updateCartUI();
